// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__DJDMv","modalText":"Modal_modalText__Ku4zS"};